<template>
  <div>
    <div v-if="![2,3,4,5,6].includes(externalSoftware)" style="font-size: 22px; font-weight: bold; padding: 60px">
        {{ $t('export.comp.datevOnly') }}
    </div>
    <SotecDashboard v-if="[2,3,4,5,6].includes(externalSoftware)"></SotecDashboard>
  </div>
</template>
<script>
import SotecDashboard from "./SotecDashboard.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    SotecDashboard,
  },
  name: "ExportSotecDashboard",
  data() {
    return {
      mode: "daily",
    };
  },
  computed: {
    ...mapGetters(["externalSoftware"]),
  },
  watch: {},
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {},
  },
};
</script>
<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped></style>
